import { logWrapper } from '../utils';

export default {
  taskModel: [
    'runtimeConstant',
    '$filter',
    '$sce',
    'ETaskTypes',
    'EXT_ICONS',
    function (runtimeConstant, $filter, $sce, ETaskTypes, EXT_ICONS) {
      function Task(data) {
        this.id = data.Id;
        this.idElement = data.IdElement;
        this.idExecution = data.IdExecution;
        this.startDate = data.StartDate;
        this.endDate = data.EndDate;

        this.execution = data.Execution;
        this.element = data.Element;
        this.element.Type =
          data.Element.Type === undefined ? 0 : data.Element.Type;
        this.revision =
          data.Execution !== undefined ? data.Execution.Revision : undefined;
        if (data.Execution && data.Execution.WorkflowRevision) {
          this.workflowRevision = data.Execution.WorkflowRevision;
          this.workflowRevision.workflow =
            data.Execution.WorkflowRevision.Workflow;
        }
        this.rowGuid = data.RowGuid;
        this.remainingDays = data.RemainingDays;
        this.dateLimit = data.DateLimit;
        this.late = data.RemainingDays && data.RemainingDays < 0 ? 1 : 0;
        this.certificatas = data.Execution !== undefined ? data.Execution.Revision.Certificatas : undefined;

        this.forms = data.Form ? data.Form : {};
      }

      function title() {
        return this.name;
      }

      function stepName() {
        if (this.element.Type === ETaskTypes.Start) {
          if (this.revision.IdRevision && this.revision.IdRevision !== 0) {
            return 'DOCUMENT REVISED';
          }

          return 'DOCUMENT SENT';
        } else if (this.element.Type === ETaskTypes.ReleaseDocument) {
          return 'DOCUMENT RELEASED';
        }
        return this.element.Name;
      }

      function details() {
        return this.description;
      }

      function elementType() {
        var type = '';

        // Task: -1,
        // Review: 0,
        // Notification: 1,
        // Decision: 2,
        // Approve: 3,
        // ApproveWithSignature: 4,
        // Training: 5,
        // Distribution: 6,
        // Analysis: 7,
        // Start: 8,
        // End: 9

        switch (this.element.Type) {
          case ETaskTypes.Review:
            type = 'REVIEW';
            break;
          case ETaskTypes.Notification:
            type = 'NOTIFICATION';
            break;
          case ETaskTypes.Decision:
            type = 'DECISION';
            break;
          case ETaskTypes.Approve:
          case ETaskTypes.ApproveWithSignature:
            type = 'APPROVE';
            break;
          case ETaskTypes.Training:
            type = 'TRAINING';
            break;
          case ETaskTypes.Distribution:
            type = 'DISTRIBUTION';
            break;
          case ETaskTypes.Analysis:
            type = 'ANALYSIS';
            break;
          case ETaskTypes.Start:
            type = 'START';
            break;
          case ETaskTypes.End:
            type = 'END';
            break;
          default:
            type = 'REVIEW';
            break;
        }

        return type;
      }

      function tags() {
        return '';
      }

      function filter() {
        var text = this.element.Name;
        text += ' ' + this.elementType();
        text += ' ' + this.element.Description;
        text += ' ' + this.revision.Title;
        text += ' ' + this.revision.Extension;
        text += ' ' + this.workflowRevision.workflow.Name;
        return text;
      }

      function icon() {
        var icon = '';

        switch (this.element.Type) {
          case ETaskTypes.Review:
            icon = 'fa fa-file-o pencil';
            break;
          case ETaskTypes.Notification:
            icon = 'fa fa-envelope';
            break;
          case ETaskTypes.Approve:
            icon = 'fa fa-check-square-o';
            break;
          case ETaskTypes.ApproveWithSignature:
            icon = 'fa fa-search-plus';
            break;
          case ETaskTypes.Training:
            icon = 'fa fa-group';
            break;
          case ETaskTypes.Distribution:
            icon = 'fa fa-print';
            break;
          case ETaskTypes.Analysis:
            icon = 'fa fa-line-chart';
            break;
          case ETaskTypes.Start:
            icon = 'fa fa-file-o';
            break;
          case ETaskTypes.Decision:
            icon = 'fa fa-code-fork';
            break;
          case ETaskTypes.End:
            icon = 'fa fa-circle';
            break;
          case ETaskTypes.ReleaseDocument:
            icon = 'fa fa-unlock-alt';
            break;
        }

        return icon;
      }

      function formView() {
        var view = '/views/modules/flow/execution/stepforms/';

        switch (this.element.Type) {
          case ETaskTypes.Review:
            view += 'review.html';
            break;
          case ETaskTypes.Notification:
            view += 'notification.html';
            break;
          case ETaskTypes.Approve:
            view += 'approve.html';
            break;
          case ETaskTypes.ApproveWithSignature:
            view += 'approve.html';
            break;
          case ETaskTypes.Training:
            view += 'training.html';
            break;
          case ETaskTypes.Distribution:
            view += 'distribution.html';
            break;
          case ETaskTypes.Analysis:
            view += 'analysis.html';
            break;
        }

        return view;
      }

      function revisionIcon() {
        var ext = this.revision.Extension;
        if (ext.toLowerCase().endsWith('p7s')) {
          var splited = ext.split('.');
          ext = splited[0];
        }

        var image =
          '<img src="/assets/images/file_extensions/large/default.png" width="32px"></img>';
        if (ext !== null && EXT_ICONS.indexOf(ext.toLowerCase()) >= 0) {
          image =
            '<img src="/assets/images/file_extensions/large/' +
            ext +
            '.png" onerror="this.src=\'/assets/images/file_extensions/large/default.png\';" width="32px"></img>';
        }
        if (this.revision.IsSigned) {
          image +=
            '<img class="large_signed_doc" src="/assets/images/document_status/seal.png" width="15px"></img>';
        }

        return $sce.trustAsHtml(image); //Show default icon when the extension icon not exists;
      }

      function remainingDaysTextShort() {
        if (this.remainingDays !== undefined && this.remainingDays !== null) {
          if (this.remainingDays < -1) {
            return String.format($filter('translate')('TASK LATE'), [
              this.remainingDays * -1,
            ]);
          } else if (this.remainingDays === -1) {
            return $filter('translate')('ONE DAY LATE');
          } else if (this.remainingDays === 1) {
            return $filter('translate')('ONE DAY LEFT');
          } else if (this.remainingDays > 1) {
            return String.format($filter('translate')('TASK REMAIN TASK'), [
              this.remainingDays,
            ]);
          } else {
            return $filter('translate')('TASK LATE TODAY');
          }
        } else {
          return $filter('translate')('NOT DEFINED');
        }
      }

      function remainingDaysText() {
        var dateFormatted = '';
        if (this.dateLimit !== undefined && this.dateLimit !== null) {
          dateFormatted = $filter('date')(this.dateLimit, 'dd/MM/yyyy') + ' - ';
        }
        return dateFormatted + this.remainingDaysTextShort();
      }

      function documentInfo() {
        return String.format($filter('translate')('DOCUMENT SEND BY AT'), [
          this.revision.Author.Name,
          $filter('date')(this.execution.StartDate, 'dd/MM/yyyy - HH:mm'),
        ]);
      }

      function run() {
        try {
          Task.prototype = {
            title: logWrapper(title, runtimeConstant.isDebugModelsInternals),
            stepName: logWrapper(
              stepName,
              runtimeConstant.isDebugModelsInternals
            ),
            details: logWrapper(
              details,
              runtimeConstant.isDebugModelsInternals
            ),
            elementType: logWrapper(
              elementType,
              runtimeConstant.isDebugModelsInternals
            ),
            tags: logWrapper(tags, runtimeConstant.isDebugModelsInternals),
            filter: logWrapper(filter, runtimeConstant.isDebugModelsInternals),
            icon: logWrapper(icon, runtimeConstant.isDebugModelsInternals),
            formView: logWrapper(
              formView,
              runtimeConstant.isDebugModelsInternals
            ),
            revisionIcon: logWrapper(
              revisionIcon,
              runtimeConstant.isDebugModelsInternals
            ),
            remainingDaysTextShort: logWrapper(
              remainingDaysTextShort,
              runtimeConstant.isDebugModelsInternals
            ),
            remainingDaysText: logWrapper(
              remainingDaysText,
              runtimeConstant.isDebugModelsInternals
            ),
            documentInfo: logWrapper(
              documentInfo,
              runtimeConstant.isDebugModelsInternals
            ),
          };

          return Task;
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error);
        }
      }

      // Wrap the setup function with logWrapper for debugging purposes
      return logWrapper(run, runtimeConstant.isDebugModels)();
    },
  ],
};
